import React, {Component} from 'react'

import Phaser from 'phaser';
import {GameContext} from "./GameContext";

export class BlankScene extends Phaser.Scene {
    constructor() {
        super({
            key: 'BlankScene',
            active: true
        });
    }

    preload() {
    }

    create() {
        const graphics = this.make.graphics({x: 0, y: 0, add: true});
        graphics.clear()
    }
}

class ConferenceGame extends Component {
    resumeScene;
    amEnabled = false;

    generateConfig = () => {
        const blankArray = [new BlankScene()]
        let scenes = this.context.venue.createScenes(this);
        const allScenes = blankArray.concat(scenes)

        this.resumeScene = scenes[0].sys.config.key

        return {
            type: Phaser.AUTO,
            parent: "phaser-game",
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            width: 1050, // Canvas width in pixels
            height: 800, // Canvas height in pixels
            // zoom: 2,
            pixelArt: true,
            physics: {
                default: 'arcade',
                arcade: {
                    gravity: {
                        y: 0
                    },
                    debug: false // set to true to view zones
                }
            },
            scene: allScenes
        }
    }

    setEnabled = (enabled) => {
        if(this.game) {
            if (this.amEnabled === enabled)
                return

            this.amEnabled = enabled

            let activeScenes = this.game.scene.getScenes(true);
            activeScenes.forEach((scene) => {
                if (scene.shutDown) {
                    scene.shutDown()
                }
            })
            const activeSceneKeys = activeScenes.map((scene) => scene.sys.config.key)

            for (let i in activeSceneKeys) {
                const key = activeSceneKeys[i]
                this.game.scene.stop(key)
            }

            if (enabled) {
                this.game.scene.start(this.resumeScene)
                this.context.setCurrentRoom(this.resumeScene)
            } else {
                if (activeSceneKeys.length === 1) {
                    this.resumeScene = activeSceneKeys[0]
                }
                this.game.scene.start("BlankScene")
                this.context.setCurrentRoom("BlankScene")
            }
        }
    }

    componentDidMount = () => {
        this.context.venue.venueDataProvider.listen((provider) => {
            const roomInfo = this.context.venue.videoAdminPanel(this.context.currentRoom)
            let streamActive = this.context.venue.venueValue(`${roomInfo.roomKey}Active`);
            if(streamActive) {
                const stream = this.context.venue.venueValue(roomInfo.roomKey);
                const streamUserId = this.context.venue.venueValue(`${roomInfo.roomKey}UserId`);
                const streamModal = this.context.venue.venueValue(`${roomInfo.roomKey}Modal`);
                this.props.setVideoOverlay({
                    stream: stream,
                    streamUserId: streamUserId,
                    streamModal: streamModal
                })
            }
            else
                this.props.setVideoOverlay(null)
        })

        this.context.connectWebsocket(this.setEnabled)
        this.game = new Phaser.Game(this.generateConfig());
    }

    componentWillUnmount() {
        if(this.game) {
            this.game.scene.getScenes(true).forEach((scene) => {
                if (scene.shutDown) {
                    scene.shutDown()
                }
            })
            this.game.destroy()
            this.game = null
        }
    }

    static contextType = GameContext;

    render() {

        if(this.game) {
            this.game.scene.getScenes(true).forEach((scene) => {
                if (this.props.talking && scene.imTalkin)
                    scene.imTalkin()
                if (!this.props.talking && scene.imNotTalkin)
                    scene.imNotTalkin()
            })

            // console.log(`resizing: ${this.props.gameWidth}/${this.props.gameHeight}`)

            this.game.scale.resize(
                this.props.gameWidth,
                this.props.gameHeight
            );
        }
        return (
            <div id="phaser-game"/>
        )
    }
}

export default ConferenceGame
